/* eslint-disable @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-argument */
import { Component, forwardRef, Input } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

import { SearchFilterMetadataModel } from "../../../models/search-filter-metadata.model";
import {SearchFilterAttributeModel} from "../../../models/search-filter-attribute.model";

@Component({
    selector: "pcg-ng-directory-search-filters",
    templateUrl: "./directory-search-filters.component.html",
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DirectorySearchFiltersComponent),
            multi: true
        }
    ]
})
export class DirectorySearchFiltersComponent implements ControlValueAccessor {
    @Input() public templateId: string;
    @Input() public searchFilters: SearchFilterMetadataModel;

    protected isFilterExpandedMobile = false;
    protected expandedFilters: Array<string> = [];
    protected selectedValues: Array<string> = [];

    private onChange: (value: any) => void;
    private onTouched: () => void;

    protected getFiltersForSection(id: string): Array<SearchFilterAttributeModel> {
        return this.searchFilters.attributes;
    }

    public registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    public writeValue(obj: Array<string>): void {
        this.selectedValues = obj || [];

        this.expandedFilters = this.searchFilters.attributes
            ?.filter(f => f.nestedAttributes.some(a => this.selectedValues?.includes(a.id)))
            .map(f => f.name);
    }

    protected toggleCheckbox(value: string): void {
        const index = this.selectedValues.indexOf(value);

        if (index > -1) {
            this.selectedValues.splice(index, 1);
        } else {
            this.selectedValues.push(value);
        }

        if (this.onChange) {
            this.onChange(this.selectedValues);
        }
    }

    protected isFilterExpanded(filter: SearchFilterAttributeModel): boolean {
        return this.expandedFilters.includes(filter.name);
    }

    protected hasSelectedFilterAttributes(filter: SearchFilterAttributeModel): boolean {
        return filter.nestedAttributes.some(attribute => this.selectedValues?.includes(attribute.id));
    }

    protected getSelectedFilterAttributes(filter: SearchFilterAttributeModel): string {
        return filter.nestedAttributes
            .filter(attribute => this.selectedValues?.includes(attribute.id))
            .map(attribute => attribute.name)
            .join(", ");
    }

    protected toggleFilter(filter: SearchFilterAttributeModel): void {
        if (this.isFilterExpanded(filter)) {
            this.expandedFilters = this.expandedFilters.filter(f => f !== filter.name);
        } else {
            this.expandedFilters.push(filter.name);
        }
    }

    protected clearFilters(e: Event): void {
        e.preventDefault();

        this.writeValue([]);
        this.onChange(this.selectedValues);
    }

    public toggleFiltersMobile(): void {
        this.isFilterExpandedMobile = !this.isFilterExpandedMobile;
    }

    public scrollToViewport(targetElement: HTMLElement): void {
        const scrollableContainer = targetElement.parentElement;

        const containerRect = scrollableContainer.getBoundingClientRect();
        const elementRect = targetElement.getBoundingClientRect();

        if (elementRect.top < containerRect.top) {
            scrollableContainer.scrollTop -= (containerRect.top - elementRect.top);
        } else if (elementRect.bottom > containerRect.bottom) {
            scrollableContainer.scrollTop += (elementRect.bottom - containerRect.bottom);
        }
    }
}
